import React from 'react';

import PsychToolPageBase, { PsychToolPageProps } from './PsychToolPageBase';

const PsychNeedsPage: React.FC<PsychToolPageProps> = ({ onBack, onRequireLogin }) => (
  <PsychToolPageBase onBack={onBack} onRequireLogin={onRequireLogin} testId='needs' />
);

export default PsychNeedsPage;
